/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import history from 'instantsearch.js/es/lib/routers/history';
import { searchBox } from 'instantsearch.js/es/widgets';
import customHits from './widgets/hits-faq';

const DOM = {
    searchForm: document.querySelector('.js-faq-search-form'),
};

let firstLoad = true;

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
        search(requests) {
            if (requests.every(({ params }) => !params.query)
                && firstLoad === true) {
                firstLoad = false;
                return Promise.resolve({
                    results: requests.map(() => ({
                        hits: [],
                        nbHits: 0,
                        nbPages: 0,
                        page: 0,
                        processingTimeMS: 0,
                    })),
                });
            }

            return algoliaClient.search(requests);
        },
    };

    const indexName = `${SWDLocalise.algoliaIndex}faq`;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const urlParts = location.href.match(/^(.*?)\/contact/);
                    const baseUrl = `${urlParts ? urlParts[1] : ''}/`;
                    const queryParameters = {};

                    // query
                    if (routeState.query) {
                        queryParameters.query = encodeURIComponent(routeState.query);
                    }

                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    // handle single URL
                    return `${baseUrl}contact/${queryString}`;
                },

                parseURL({ qsModule, location }) {
                    const {
                        query = '',
                    } = qsModule.parse(
                        location.search.slice(1),
                    );

                    return {
                        query: decodeURIComponent(query),
                    };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_spb_faq || {};

                    return { query: indexUiState.query };
                },

                routeToState(routeState) {
                    return {
                        wp_spb_faq: { query: routeState.query },
                    };
                },
            },
        },
    });

    search.addWidgets([
        searchBox({
            container: DOM.searchForm,
            placeholder: 'Search',
        }),

        customHits({
            container: document.querySelector('.js-faq-search-results'),
        }),
    ]);

    search.start();
};

const init = () => {
    if (!DOM.searchForm) return;
    setup();
};

export default init;
